export const CHANGE_GLOBAL_DISPLAY_GROUP = 'CHANGE_GLOBAL_DISPLAY_GROUP';
export const CHANGE_CURRENT_FEATURE = 'CHANGE_CURRENT_FEATURE';
export const CHNAGE_PRIMARY_SIDEBAR_DISPLAY = 'CHNAGE_PRIMARY_SIDEBAR_DISPLAY';
export const CHANGE_MOBILE_VIEW = 'CHANGE_MOBILE_VIEW';
export const SET_ORG_LIST = 'SET_ORG_LIST';
export const SET_SELECTED_ORG = 'SET_SELECTED_ORG';
export const SET_GROUPS = 'SET_GROUPS';
export const CHANGE_FEATURES_RESPONSE = 'CHANGE_FEATURES_RESPONSE';
